import React, { useContext } from "react";
import { CardBody, Col, Label, Row } from "reactstrap";
import { ViewOfferContext } from "./context";

const ViewOfferChargesRecurring = ({ chargesRecurringList }) => {
  const { sectionRefs } = useContext(ViewOfferContext);
  return (
    <CardBody>
      {chargesRecurringList?.length === 0 ? (
        <div className="text-center">No Charges</div>
      ) : (
        chargesRecurringList?.map((charge, index) => {
          const chargeRef = sectionRefs.current[`recurringCharges${index + 1}`];
          return (
            <div
              key={index}
              className="border border-opacity-50 rounded-0 mb-3"
              ref={chargeRef}
            >
              <Row
                className={`mb-3 px-3 pt-3 ${
                  index === chargesRecurringList?.length - 1
                    ? ""
                    : "border-bottom"
                }`}
                key={index}
              >
                <Col
                  xs={12}
                  className="d-flex justify-content-between align-items-center pb-4"
                >
                  <h3 className="card-title mb-0">
                    Charge {index > 0 ? index + 1 : ""}-{" "}
                    {charge?.type == 1 ? "One Time" : "Recurring"}
                  </h3>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Recurring Frequency</Label>
                  <p>
                    {charge?.recurringFrequency
                      ? charge?.recurringFrequency?.label
                      : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Recurring Frequency Unit</Label>
                  <p>
                    {charge?.recurringFrequencyUnit
                      ? charge?.recurringFrequencyUnit
                      : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Cycle Alignment</Label>
                  <p>
                    {charge?.cycleAlignment
                      ? charge?.cycleAlignment?.label
                      : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`recurringCharges[${index}].resourceType`}
                    className="fw-bold"
                  >
                    Resource Type
                  </Label>
                  <p>
                    {charge?.resourceType ? charge?.resourceType?.label : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`recurringCharges[${index}].resourceValue`}
                    className="fw-bold"
                  >
                    Resource Value
                  </Label>
                  <p>{charge?.resourceValue ? charge?.resourceValue : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Type of Resource</Label>
                  <p>{"Currency"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`recurringCharges[${index}].ceiling`}
                    className="fw-bold"
                  >
                    Ceiling
                  </Label>
                  <p>{charge?.ceiling ? charge?.ceiling : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`recurringCharges[${index}].floor`}
                    className="fw-bold"
                  >
                    Floor
                  </Label>
                  <p>{charge?.floor ? charge?.floor : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`recurringCharges[${index}].infinite`}
                    className="fw-bold"
                  >
                    Infinite
                  </Label>
                  <p>{charge?.infinite ? charge?.infinite?.label : "-"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Prorate</Label>
                  <p>{charge?.prorate ? "Yes" : "No"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Override</Label>
                  <p>{charge?.override ? "Yes" : "No"}</p>
                </Col>
              </Row>
            </div>
          );
        })
      )}
    </CardBody>
  );
};

export default ViewOfferChargesRecurring;
